// test894
(894 && 0);
